"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const address_service_1 = require("./address.service");
const create_address_dto_1 = require("./dto/create-address.dto");
const update_address_dto_1 = require("./dto/update-address.dto");
const address_swagger_1 = require("./address.swagger");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const enum_1 = require("../../../../../../libs/service-lib/src/lib/enum");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
let AddressController = class AddressController {
    constructor(addressService) {
        this.addressService = addressService;
    }
    /* Below controller will Creates a new address. with the help of the data object validated using `createAddressDto`. */
    async addAddress(address, res, req) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * addAddress *", req.headers);
            const userId = parseInt(req?.headers?.userid);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const data = await this.addressService.addAddress(address, userId);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * addAddress * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * addAddress * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.addressCreated, data));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.internalServerError)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Retrieves the list of all addresses.*/
    async getAddressList(res, req, page = constants_1.DEFAULT_PAGE, limit = constants_1.DEFAULT_LIMIT, search, sort) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getAddressList *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const { data, count } = await this.addressService.getAddressList(page, limit, search, sort);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getAddressList * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getAddressList * ${responseTime - requestStartTime}ms`);
            return res.status(enum_1.statusCode.ok).json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.addressListRetrieved, {
                data,
                count,
            }));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.internalServerError)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Retrieves an address by its ID.*/
    async getAddressById(addressId, res, req) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getAddressById *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const address = await this.addressService.getAddressById(addressId);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getAddressById * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getAddressById * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.addressDetails, address));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.notFound)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Updates an address by its ID.*/
    async updateAddressById(addressId, updateAddress, res, req) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * updateAddressById *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const userId = parseInt(req?.headers?.userid);
            const updatedAddress = await this.addressService.updateAddressById(addressId, updateAddress, userId);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * updateAddressById * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * updateAddressById * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.addressUpdated, updatedAddress));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.internalServerError)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Deletes an address by its ID. */
    async deleteAddressById(addressId, res, req) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * deleteAddressById *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            await this.addressService.deleteAddressById(addressId);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * deleteAddressById * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * deleteAddressById * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.addressDeleted));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.notFound)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Retrieves the region details */
    async getAllRegions(res, req) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getAllRegions *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const regions = await this.addressService.getAllRegions();
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getAllRegions * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getAllRegions * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.regionListFetched, regions));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.internalServerError)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Retrieves all country details */
    async getAllCountries(res, req) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getAllCountries *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const countries = await this.addressService.getAllCountries();
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getAllCountries * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getAllCountries * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.countryListFetched, countries));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.internalServerError)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Retrieves all country details based upon region */
    async getCountries(res, req, regionId) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getCountries *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const countries = await this.addressService.getCountries(regionId);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getCountries * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getCountries * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.countryListFetched, countries));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.internalServerError)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Retrieves all state details based upon country */
    async getStates(res, req, countryId) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getStates *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const states = await this.addressService.getStates(countryId);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getStates * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getStates * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.stateListFetched, states));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.internalServerError)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Retrieves all city details based upon state */
    async getCities(res, req, stateId) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getCities *", req.headers);
            const serviceStartTime = Date.now(); // Record the service execution start time
            const cities = await this.addressService.getCities(stateId);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getCities * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getCities * ${responseTime - requestStartTime}ms`);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.cityListFetched, cities));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.internalServerError)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
};
exports.AddressController = AddressController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, address_swagger_1.createAddressSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_b = typeof create_address_dto_1.CreateAddressDto !== "undefined" && create_address_dto_1.CreateAddressDto) === "function" ? _b : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "addAddress", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, address_swagger_1.getAddressesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Query)("page")),
    tslib_1.__param(3, (0, common_1.Query)("limit")),
    tslib_1.__param(4, (0, common_1.Query)("search")),
    tslib_1.__param(5, (0, common_1.Query)("sort")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Number, Number, String, String]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "getAddressList", null);
tslib_1.__decorate([
    (0, common_1.Get)(":id"),
    (0, address_swagger_1.getAddressSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "getAddressById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":id"),
    (0, address_swagger_1.updateAddressSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_c = typeof update_address_dto_1.UpdateAddressDto !== "undefined" && update_address_dto_1.UpdateAddressDto) === "function" ? _c : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "updateAddressById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":id"),
    (0, address_swagger_1.deleteAddressSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "deleteAddressById", null);
tslib_1.__decorate([
    (0, common_1.Get)("region/list"),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "getAllRegions", null);
tslib_1.__decorate([
    (0, common_1.Get)("country/list"),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "getAllCountries", null);
tslib_1.__decorate([
    (0, common_1.Get)("country/:regionId"),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Param)("regionId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "getCountries", null);
tslib_1.__decorate([
    (0, common_1.Get)("state/:countryId"),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Param)("countryId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "getStates", null);
tslib_1.__decorate([
    (0, common_1.Get)("city/:stateId"),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Param)("stateId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], AddressController.prototype, "getCities", null);
exports.AddressController = AddressController = tslib_1.__decorate([
    (0, common_1.Controller)("address"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof address_service_1.AddressService !== "undefined" && address_service_1.AddressService) === "function" ? _a : Object])
], AddressController);
